import { useAiReceptionistStateSuppress } from './use-ai-receptionist-state-suppress';
import { useSmsNotificationPausePreference } from './use-sms-notification-pause-preference';

export const useNotificationPreferences = () => {
  useAiReceptionistStateSuppress();
  useSmsNotificationPausePreference();
};
